var _g, _rect, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHistoryExchangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 3.73885C18 2.9917 17.3246 2.42619 16.5891 2.55754L2.98905 4.98611C2.41674 5.08831 2 5.58605 2 6.16742V6.99997V7.99997V20C2 20.2652 2.10536 20.5195 2.29289 20.7071C2.48043 20.8946 2.73478 21 3 21H21C21.2652 21 21.5196 20.8946 21.7071 20.7071C21.8946 20.5195 22 20.2652 22 20V7.99997C22 7.73475 21.8946 7.4804 21.7071 7.29286C21.5196 7.10533 21.2652 6.99997 21 6.99997H19H18V3.73885ZM16 6.99997V4.69436L4 6.83722V6.99997H16ZM4 8.99997V19H20V8.99997H4ZM15 13H18V15H15V13Z",
    fill: "#F8FAFC"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.5,
    y: 13.5,
    width: 13,
    height: 13,
    rx: 6.5,
    fill: "#2D3344",
    stroke: "#2D3344"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M24 22V20L26.5 22.5L24 25V23H18V22H24ZM20 15V16.9995L26 17V18H20V20L17.5 17.5L20 15Z",
    fill: "#94A3B8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6290_11582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6290_11582"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(16 14)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistoryExchangeIcon);
export default __webpack_public_path__ + "static/media/history_exchange_icon.d38c66da163cc894d60757cab4ea80cc.svg";
export { ForwardRef as ReactComponent };